import { BasePayloadMapper } from '@ps/utils';

import { SearchQuestionsParams } from '../../models/parent-question.model';
import { SearchQuestionsRequestDto } from '../dtos/parent-question.dto';

export class ParentQuestionPayloadMapper extends BasePayloadMapper<
  SearchQuestionsParams,
  SearchQuestionsRequestDto
> {
  public toPayload(params: SearchQuestionsParams): SearchQuestionsRequestDto {
    return {
      locale: params.locale,
      dp: params.dp ?? 0,
      dq: params.dq ?? 0,
      ...(params.enableSegmentation && { enableSegmentation: 'true' }),
      ...(params.segmentationDependentQuestion && {
        segmentationDependentQuestion: 'true',
      }),
    };
  }
}
